export default __webpack_public_path__ + "static/media/3536 utensils top.f8bd34fe.png";